<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 500px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Add Mechanical Services Switch Board (MSSB)</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit" @reset="onReset">
        <q-card-section>
          <q-select
            :model-value="formData.parent_msb"
            label="Parent MSB *"
            filled
            :options="msbOptions"
            emit-value
            map-options
            :rules="[val => !!val || 'Parent MSB is required']"
            class="q-mb-md"
            @update:model-value="emit('update:parent-msb', $event)"
          />

          <q-input
            :model-value="formData.name"
            label="Name *"
            filled
            :rules="[val => !!val || 'Name is required']"
            class="q-mb-md"
            @update:model-value="emit('update:name', $event)"
          />

          <q-input
            :model-value="formData.description"
            label="Description"
            filled
            type="textarea"
            rows="2"
            class="q-mb-md"
            @update:model-value="emit('update:description', $event)"
          />

          <q-input
            :model-value="formData.current_rating"
            label="Current Rating"
            filled
            hint="e.g., 400A"
            class="q-mb-md"
            @update:model-value="emit('update:current-rating', $event)"
          />

          <q-select
            :model-value="formData.service_type"
            label="Service Type"
            filled
            :options="serviceTypeOptions"
            class="q-mb-md"
            @update:model-value="emit('update:service-type', $event)"
          />

          <q-select
            :model-value="formData.location"
            label="Location"
            filled
            :options="locationOptions"
            emit-value
            map-options
            @update:model-value="emit('update:location', $event)"
          />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn flat label="Reset" type="reset" color="warning" />
          <q-btn unelevated label="Save" type="submit" color="orange" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    msbOptions: {
      type: Array,
      default: () => [],
    },
    serviceTypeOptions: {
      type: Array,
      default: () => [],
    },
    locationOptions: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:parent-msb',
    'update:name',
    'update:description',
    'update:current-rating',
    'update:service-type',
    'update:location',
    'submit',
    'reset',
  ]);

  function onSubmit() {
    emit('submit');
  }

  function onReset() {
    emit('reset');
  }
</script>
